var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");

var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;

var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);

  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};

var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

var __markAsModule = target => __defProp(target, "__esModule", {
  value: true
});

var __objRest = (source, exclude) => {
  var target = {};

  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];

  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

var __export = (target, all) => {
  __markAsModule(target);

  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2)) if (!__hasOwnProp.call(target, key) && key !== "default") __defProp(target, key, {
      get: () => module2[key],
      enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable
    });
  }

  return target;
};

var __toModule = module2 => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? {
    get: () => module2.default,
    enumerable: true
  } : {
    value: module2,
    enumerable: true
  })), module2);
};

__export(exports, {
  default: () => UsStatesSelect_default2
});

var import_react15 = __toModule(require("react"));

var import_react4 = __toModule(require("react"));

var import_core = __toModule(require("@linaria/core"));

var import_react = __toModule(require("react"));

var initialState = {
  isExpanded: false,
  setIsExpanded: () => {},
  onChange: () => {},
  selectedValue: "",
  menuId: "",
  registerOption: () => {},
  options: {
    current: {
      options: [],
      disabledOptions: []
    }
  },
  isMultiselect: false,
  selectedValues: [],
  filteredOptions: [],
  setFilteredOptions: () => {}
};
var SelectContext = (0, import_react.createContext)(initialState);

var SelectProvider = _ref => {
  let {
    isMultiselect,
    onChange,
    menuId,
    selectedValue,
    selectedValues,
    children
  } = _ref;
  const [isExpanded, setIsExpanded] = (0, import_react.useState)(false);
  const [filteredOptions, setFilteredOptions] = (0, import_react.useState)([]);
  const options = (0, import_react.useRef)({
    options: [],
    disabledOptions: []
  });

  const registerOption = (value, disabled) => {
    if (options.current.options.includes(value)) return;
    options.current = {
      options: [].concat(_toConsumableArray(options.current.options), [value]),
      disabledOptions: disabled ? [].concat(_toConsumableArray(options.current.disabledOptions), [value]) : options.current.disabledOptions
    };
    setFilteredOptions(options.current.options);
  };

  return import_react.default.createElement(SelectContext.Provider, {
    value: {
      isExpanded,
      onChange,
      setIsExpanded,
      selectedValue,
      selectedValues,
      menuId,
      registerOption,
      options,
      isMultiselect,
      filteredOptions,
      setFilteredOptions
    }
  }, children);
};

var import_react2 = __toModule(require("react"));

var import_react3 = __toModule(require("@linaria/react"));

var import_showroom_css_theme = __toModule(require("@carvana/showroom-css-theme"));

var SelectWrapper = (0, import_react3.styled)("div")({
  name: "SelectWrapper",
  class: "s1nf4q5s"
});
var SelectInput = (0, import_react3.styled)("button")({
  name: "SelectInput",
  class: "ss0njt0"
});
var SelectCaption = (0, import_react3.styled)("p")({
  name: "SelectCaption",
  class: "sx3rssh"
});
var OptionWrapper = (0, import_react3.styled)("div")({
  name: "OptionWrapper",
  class: "o519fet"
});
var OptionsContainer = (0, import_react3.styled)("div")({
  name: "OptionsContainer",
  class: "o1s0jnet"
});
var Path = (0, import_react3.styled)("path")({
  name: "Path",
  class: "phuhfvz",
  vars: {
    "phuhfvz-0": [_ref2 => {
      let {
        fill
      } = _ref2;
      return fill || "var(--cvna-color-blue-2)";
    }]
  }
});

var CaretDown = _ref3 => {
  let {
    disabled
  } = _ref3;
  return import_react2.default.createElement("svg", {
    width: "9",
    height: "5",
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, import_react2.default.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5.45614L0 0.543861H9L4.5 5.45614Z",
    className: disabled && "is-disabled"
  }));
};

var CaretUp = () => import_react2.default.createElement("svg", {
  width: "9",
  height: "5",
  viewBox: "0 0 9 5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, import_react2.default.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 0L0 5H9L4.5 0Z"
}));

var Checkmark = () => import_react2.default.createElement("svg", {
  width: "9",
  height: "7",
  viewBox: "0 0 9 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, import_react2.default.createElement(Path, {
  d: "M3.10104 7L0.272375 4.27132C-0.0907918 3.90632 -0.0907918 3.34196 0.272375 2.97695C0.444094 2.80521 0.684592 2.70769 0.9364 2.70769C1.18821 2.70769 1.42871 2.80521 1.60042 2.97695L3.10104 4.43224L7.40032 0.269263C7.57204 0.0975222 7.81254 0 8.06435 0C8.31615 0 8.55665 0.0975222 8.72837 0.269263C9.09054 0.631941 9.09054 1.19396 8.72837 1.55664L3.10104 7Z"
}));

var CheckboxOn = () => import_react2.default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  className: "icon-checkbox-on"
}, import_react2.default.createElement("rect", {
  width: "100%",
  height: "100%",
  fill: "#fff",
  rx: "3"
}), import_react2.default.createElement(Path, {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3Zm13.766 9.697a1 1 0 0 0-1.532-1.286l-4.877 5.806-.078-.083-1.551-1.645a1 1 0 0 0-1.456 1.372l1.552 1.645.605.642.179.19.048.05.012.014.003.003.001.001.728-.686-.728.686a1 1 0 0 0 1.494-.042l5.6-6.667Z"
}));

var CheckboxOff = () => import_react2.default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, import_react2.default.createElement(Path, {
  d: "M21 .5H3A2.5 2.5 0 0 0 .5 3v18A2.5 2.5 0 0 0 3 23.5h18a2.5 2.5 0 0 0 2.5-2.5V3A2.5 2.5 0 0 0 21 .5Z",
  stroke: "currentColor",
  fill: "none"
}));

var filterOrAddValue = (T1, T2) => {
  return (T1 == null ? void 0 : T1.includes(T2)) ? T1 == null ? void 0 : T1.filter(x => x !== T2) : [].concat(_toConsumableArray(T1), [T2]);
};

var Option = _ref4 => {
  let {
    children,
    disabled = false,
    value,
    className,
    innerRef
  } = _ref4;
  const {
    onChange,
    setIsExpanded,
    menuId,
    registerOption,
    selectedValue,
    selectedValues,
    isMultiselect,
    filteredOptions
  } = (0, import_react4.useContext)(SelectContext);
  const showOption = filteredOptions.includes(value);
  const isSelected = isMultiselect ? selectedValues.includes(value) : selectedValue === value;
  const classNames = (0, import_core.cx)(isSelected && "is-selected", isMultiselect && "is-multiselect", disabled && "is-disabled", className);
  (0, import_react4.useEffect)(() => {
    registerOption(value, disabled);
  }, [registerOption, value, disabled]);
  return (0, import_react4.useMemo)(() => {
    const handleOnClick = event => {
      if (disabled) return;

      const newEvent = __spreadValues({}, event);

      if (isMultiselect) {
        const newValues = filterOrAddValue(selectedValues, value);
        newEvent.target.value = newValues;
      } else {
        newEvent.target.value = value;
        setIsExpanded(false);
      }

      onChange(newEvent);
    };

    if (!showOption) return null;
    return import_react4.default.createElement(OptionWrapper, {
      role: "option",
      onClick: handleOnClick,
      className: classNames,
      "aria-selected": isSelected,
      id: menuId + "_" + value,
      ref: innerRef
    }, children, isMultiselect && isSelected && import_react4.default.createElement(CheckboxOn, null), isMultiselect && !isSelected && import_react4.default.createElement(CheckboxOff, null), !isMultiselect && isSelected && import_react4.default.createElement(Checkmark, null));
  }, [innerRef, children, classNames, disabled, isMultiselect, isSelected, menuId, onChange, selectedValues, setIsExpanded, showOption, value]);
};

var Option_default = (0, import_react4.forwardRef)((props, ref) => import_react4.default.createElement(Option, __spreadProps(__spreadValues({}, props), {
  innerRef: ref
})));

var import_react14 = __toModule(require("react"));

var import_core4 = __toModule(require("@linaria/core"));

var import_react5 = __toModule(require("react"));

var useOutsideClickRef = callback => {
  const outsideClickRef = (0, import_react5.useRef)(null);
  const handleClick = (0, import_react5.useCallback)(event => {
    const isClickInsideElement = outsideClickRef && outsideClickRef.current && outsideClickRef.current.contains(event.target);

    if (isClickInsideElement) {
      return;
    }

    callback();
  }, [callback]);
  (0, import_react5.useEffect)(() => {
    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [handleClick]);
  return outsideClickRef;
};

var useOutsideClickRef_default = useOutsideClickRef;

var import_react6 = __toModule(require("react"));

var useKeyboardEvents = _ref5 => {
  let {
    initRef,
    listRef,
    searchInputRef,
    isAutocomplete = false,
    context,
    children,
    childrenRef,
    multiselectIndex = {
      current: -1
    },
    multiselectHoveredOption
  } = _ref5;
  const searchString = (0, import_react6.useRef)("");
  const timeout = (0, import_react6.useRef)();
  const [currentOptions, setCurrentOptions] = (0, import_react6.useState)([]);
  const {
    menuId,
    isExpanded,
    isMultiselect,
    setIsExpanded,
    selectedValue,
    onChange,
    setSelectedValue,
    onSelection,
    filteredOptions
  } = (0, import_react6.useContext)(context);
  (0, import_react6.useEffect)(() => {
    return () => clearTimeout(timeout.current);
  }, []);

  const createFlatChildArray = c => import_react6.Children.toArray(c).map(el => {
    var _a;

    if ((0, import_react6.isValidElement)(el)) {
      return (_a = el == null ? void 0 : el.props) == null ? void 0 : _a.value;
    }

    return el;
  });

  (0, import_react6.useEffect)(() => {
    setCurrentOptions(createFlatChildArray(children));
  }, [children, selectedValue]);
  return event => {
    var _a, _b, _c;

    const {
      key
    } = event;
    const listElement = listRef.current;
    const buttonElement = initRef.current;

    const newEvent = __spreadValues({}, event);

    const currentlySelectedIndex = isMultiselect ? multiselectIndex.current : currentOptions.indexOf(selectedValue);
    const listIsActive = document.activeElement === listElement;
    const buttonIsActive = document.activeElement === buttonElement;
    if (!listElement || !currentOptions.length) return;

    const focusList = () => {
      if (!listIsActive) {
        listElement.focus();
      }
    };

    const changeWithValue = newValue => {
      newEvent.target.value = newValue;

      if (onChange) {
        if (isMultiselect) return;
        onChange(newEvent);
      }

      if (setSelectedValue) setSelectedValue(newValue);
    };

    const getArrowDownIndex = n => n < 0 ? 0 : n + 1;

    const scrollArrowKeyOption = (prevChild, nextChild) => {
      var _a2, _b2;

      const activeKeyClass = "is-key-active";
      (_a2 = prevChild == null ? void 0 : prevChild.classList) == null ? void 0 : _a2.remove(activeKeyClass);
      (_b2 = nextChild == null ? void 0 : nextChild.classList) == null ? void 0 : _b2.add(activeKeyClass);
      listElement.scrollTo({
        top: nextChild == null ? void 0 : nextChild.offsetTop,
        behavior: "smooth"
      });
    };

    const selectOptionAndCloseDropdown = () => {
      const currentChild = multiselectChildren[multiselectIndex.current];
      currentChild == null ? void 0 : currentChild.click();
      setIsExpanded(false);
      buttonElement.focus();
    };

    let multiselectChildren = [];

    if (isMultiselect) {
      const filteredOptionsWithId = filteredOptions == null ? void 0 : filteredOptions.map(v => menuId + "_" + v);
      multiselectChildren = (_b = (_a = childrenRef == null ? void 0 : childrenRef.current) == null ? void 0 : _a.filter(data => data && (filteredOptionsWithId == null ? void 0 : filteredOptionsWithId.includes(data == null ? void 0 : data.id)))) != null ? _b : [];
    }

    if (document.activeElement === (searchInputRef == null ? void 0 : searchInputRef.current)) return;

    switch (key) {
      case " ":
        {
          if (isMultiselect) {
            selectOptionAndCloseDropdown();
          }

          break;
        }

      case "ArrowDown":
        {
          if (!isExpanded) {
            setIsExpanded(true);
          }

          focusList();
          if (currentlySelectedIndex === currentOptions.length - 1) return;
          if (isMultiselect && multiselectIndex.current === multiselectChildren.length - 1) return;
          const nextIndex = getArrowDownIndex(isMultiselect ? multiselectIndex.current : currentlySelectedIndex);

          if (isMultiselect) {
            multiselectIndex.current = nextIndex;
            const prevChild = multiselectChildren[nextIndex > 0 ? nextIndex - 1 : 0];
            const nextChild = multiselectChildren[nextIndex];

            if (multiselectHoveredOption) {
              multiselectHoveredOption.current = nextChild;
            }

            scrollArrowKeyOption(prevChild, nextChild);
          }

          changeWithValue(currentOptions[nextIndex]);

          if (onChange) {
            if (isMultiselect) return;
            onChange(newEvent);
          }

          if (setSelectedValue) setSelectedValue((_c = event == null ? void 0 : event.target) == null ? void 0 : _c.value);
          break;
        }

      case "ArrowUp":
        {
          if (!isExpanded) {
            setIsExpanded(true);
          }

          focusList();
          if (currentlySelectedIndex <= 0) return;
          const nextIndex = isMultiselect ? multiselectIndex.current - 1 : currentlySelectedIndex - 1;

          if (isMultiselect) {
            multiselectIndex.current = nextIndex;
            const prevChild = multiselectChildren[nextIndex + 1];
            const nextChild = multiselectChildren[nextIndex];

            if (multiselectHoveredOption) {
              multiselectHoveredOption.current = nextChild;
            }

            scrollArrowKeyOption(prevChild, nextChild);
          }

          changeWithValue(currentOptions[nextIndex]);
          break;
        }

      case "Enter":
        {
          if (isMultiselect && listIsActive) {
            selectOptionAndCloseDropdown();
            return;
          }

          if (listIsActive) {
            setIsExpanded(false);
            buttonElement.focus();
            if (onSelection) onSelection(currentOptions[currentlySelectedIndex]);
          }

          if (buttonIsActive && isExpanded) {
            listElement.focus();
          }

          break;
        }

      case "Home":
        {
          const [firstValue] = currentOptions;

          if (isExpanded && selectedValue !== firstValue) {
            focusList();
            changeWithValue(firstValue);
          }

          break;
        }

      case "End":
        {
          const lastValue = currentOptions[currentOptions.length - 1];

          if (isExpanded && selectedValue !== lastValue) {
            focusList();
            changeWithValue(lastValue);
          }

          break;
        }

      case "Escape":
        {
          if (isExpanded) {
            setIsExpanded(false);
            buttonElement.focus();
          }

          break;
        }

      default:
        {
          if (isAutocomplete) return;
          searchString.current += key;
          clearTimeout(timeout.current);
          if (typeof window === "undefined") return;
          timeout.current = window.setTimeout(() => {
            const selectedIndex = currentOptions.indexOf(selectedValue);
            const sortedOptions = [].concat(_toConsumableArray(currentOptions.slice(selectedIndex + 1)), _toConsumableArray(currentOptions.slice(0, selectedIndex + 1)));
            const searchArray = selectedIndex < 0 ? currentOptions : sortedOptions;
            const match = searchArray.find(x => x.toLowerCase().startsWith(searchString.current.toLowerCase()));

            if (match) {
              if (isMultiselect) {
                const childMatch = multiselectChildren.find(el => el.id === menuId + "_" + match);

                if (childMatch) {
                  listElement.scrollTo({
                    top: childMatch == null ? void 0 : childMatch.offsetTop,
                    behavior: "smooth"
                  });
                  childMatch.click();
                }
              }

              changeWithValue(match);
            }

            searchString.current = "";
          }, 200);
        }
    }
  };
};

var useKeyboardEvents_default = useKeyboardEvents;

var import_react11 = __toModule(require("react"));

var import_react12 = __toModule(require("@linaria/react"));

var import_showroom_css_theme3 = __toModule(require("@carvana/showroom-css-theme"));

var import_react8 = __toModule(require("react"));

var import_core2 = __toModule(require("@linaria/core"));

var import_react7 = __toModule(require("@linaria/react"));

var import_showroom_css_theme2 = __toModule(require("@carvana/showroom-css-theme"));

var DefaultButton = (0, import_react7.styled)("button")({
  name: "DefaultButton",
  class: "d14aom7e"
});
var Button = (0, import_react8.forwardRef)((_a, ref) => {
  var _b = _a,
      {
    size = "large",
    testId = "Button",
    className = "",
    mode,
    children,
    type = "button"
  } = _b,
      restProps = __objRest(_b, ["size", "testId", "className", "mode", "children", "type"]);

  return import_react8.default.createElement(DefaultButton, __spreadValues({
    ref,
    "data-testid": testId,
    className: (0, import_core2.cx)(className, mode + "-mode", size + "-size"),
    type
  }, restProps), children);
});
var Button_default = Button;
var Base_default = Button_default;

var import_react9 = __toModule(require("react"));

var Search = props => import_react9.default.createElement("svg", __spreadValues({
  width: "15",
  height: "15",
  viewBox: "0 0 15 15"
}, props), import_react9.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-.523 4.89a6 6 0 1 1 1.414-1.414l3.816 3.817a1 1 0 0 1-1.414 1.414l-3.816-3.816z",
  fill: "currentColor"
}));

var Search_default = Search;

var import_react10 = __toModule(require("react"));

var Close = props => import_react10.default.createElement("svg", __spreadValues({
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "currentColor"
}, props), import_react10.default.createElement("path", {
  d: "M7.58 6.5l5.2-5.19a.79.79 0 000-1.09.79.79 0 00-1.09 0L6.5 5.42 1.31.22a.79.79 0 00-1.09 0 .79.79 0 000 1.09l5.2 5.19-5.2 5.19a.79.79 0 000 1.09.77.77 0 00.55.22.76.76 0 00.54-.22l5.19-5.2 5.19 5.2a.79.79 0 001.09 0 .79.79 0 000-1.09z"
}));

var Close_default = Close;
var SearchInputWrapper = (0, import_react12.styled)("div")({
  name: "SearchInputWrapper",
  class: "sen3z43"
});
var SearchInput = (0, import_react12.styled)("input")({
  name: "SearchInput",
  class: "sjoptv2"
});
var ClearButton = (0, import_react12.styled)(Base_default)({
  name: "ClearButton",
  class: "c11xws5v"
});

var defaultOnChangeCallback = (searchValue, options) => {
  return options.filter(option => searchValue ? option.includes(searchValue) : true);
};

var SelectSearchInput = _ref6 => {
  let {
    callback,
    innerRef
  } = _ref6;
  const {
    options,
    setFilteredOptions
  } = (0, import_react11.useContext)(SelectContext);
  const {
    current
  } = options;

  const onChange = event => {
    var _a;

    const {
      value
    } = event.target;
    const cb = callback || defaultOnChangeCallback;
    const result = cb(value, (_a = current == null ? void 0 : current.options) != null ? _a : []);
    const filteredOptions = Array.isArray(result) ? result : [result];
    setFilteredOptions(filteredOptions);
  };

  const clearSearch = () => {
    var _a;

    setFilteredOptions((_a = current == null ? void 0 : current.options) != null ? _a : []);

    if (innerRef.current) {
      innerRef.current.value = "";
    }
  };

  return import_react11.default.createElement(SearchInputWrapper, null, import_react11.default.createElement(SearchInput, {
    type: "text",
    placeholder: "Search",
    onChange,
    ref: innerRef
  }), import_react11.default.createElement(Search_default, {
    className: "search__magnifyIcon"
  }), import_react11.default.createElement(ClearButton, {
    "aria-label": "Clear Search",
    onClick: clearSearch
  }, import_react11.default.createElement(Close_default, null)));
};

var SelectSearchInput_default = (0, import_react11.forwardRef)((props, ref) => import_react11.default.createElement(SelectSearchInput, __spreadProps(__spreadValues({}, props), {
  innerRef: ref
})));

var import_react13 = __toModule(require("react"));

var import_core3 = __toModule(require("@linaria/core"));

var checkAllSelected = (options, selected) => options.length > 0 && options.length === selected.length && options.every(option => selected.includes(option));

var SelectAllOption = _ref7 => {
  let {
    disabled = false,
    label,
    innerRef
  } = _ref7;
  const {
    onChange,
    menuId,
    selectedValues,
    options
  } = (0, import_react13.useContext)(SelectContext);
  const {
    current
  } = options;
  const classNames = (0, import_core3.cx)("is-multiselect", disabled && "is-disabled", "select-all-option");
  return (0, import_react13.useMemo)(() => {
    var _a, _b;

    const allOptions = (_a = current == null ? void 0 : current.options) != null ? _a : [];
    const disabledOptions = (_b = current == null ? void 0 : current.disabledOptions) != null ? _b : [];
    const initialOptions = disabledOptions.filter(option => selectedValues.includes(option));
    const allEnabledOptions = allOptions.filter(option => {
      return disabledOptions.includes(option) ? selectedValues.includes(option) : true;
    });
    const allSelected = checkAllSelected(allEnabledOptions, selectedValues);

    const handleSelectAllClick = event => {
      if (disabled) return;
      const newValues = allSelected ? initialOptions : allEnabledOptions;

      const newEvent = __spreadValues({}, event);

      newEvent.target.value = newValues;
      onChange(newEvent);
    };

    return import_react13.default.createElement(OptionWrapper, {
      role: "option",
      onClick: handleSelectAllClick,
      className: classNames,
      "aria-selected": allSelected,
      id: menuId + "_allSelect",
      ref: innerRef
    }, label, allSelected ? import_react13.default.createElement(CheckboxOn, null) : import_react13.default.createElement(CheckboxOff, null));
  }, [innerRef, current, classNames, disabled, label, menuId, onChange, selectedValues]);
};

var SelectAllOption_default = (0, import_react13.forwardRef)((props, ref) => import_react13.default.createElement(SelectAllOption, __spreadProps(__spreadValues({}, props), {
  innerRef: ref
})));

var BaseSelect = _a => {
  var _b = _a,
      {
    id,
    children,
    disabled = false,
    className,
    label,
    style,
    error,
    touched,
    caption,
    testId = "Select",
    forwardedRef,
    displayValueTransform = f => f,
    searchable = false,
    selectAllOption,
    onBlur = () => {}
  } = _b,
      restProps = __objRest(_b, ["id", "children", "disabled", "className", "label", "style", "error", "touched", "caption", "testId", "forwardedRef", "displayValueTransform", "searchable", "selectAllOption", "onBlur"]);

  const {
    isExpanded,
    isMultiselect,
    setIsExpanded,
    selectedValue,
    selectedValues
  } = (0, import_react14.useContext)(SelectContext);
  const [showError, setShowError] = (0, import_react14.useState)(false);

  const clearMultiselectHoveredStyle = () => {
    const activeHovered = multiselectHoveredOption == null ? void 0 : multiselectHoveredOption.current;
    const activeKeyClassname = "is-key-active";

    if (activeHovered == null ? void 0 : activeHovered.classList.contains(activeKeyClassname)) {
      activeHovered.classList.remove(activeKeyClassname);
    }
  };

  (0, import_react14.useEffect)(() => {
    if (error) {
      if (typeof touched === "boolean") {
        if (touched) setShowError(true);
      } else {
        setShowError(true);
      }
    }
  }, [error, touched]);
  (0, import_react14.useEffect)(() => {
    if (isExpanded && isMultiselect) {
      const listEl = listRef.current;

      if (listEl) {
        listEl.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    }

    if (!isExpanded) {
      clearMultiselectHoveredStyle();
      multiselectIndex.current = -1;
    }
  }, [isExpanded, isMultiselect]);
  (0, import_react14.useEffect)(() => {
    var _a2;

    if (isExpanded) {
      const elemId = id + "_" + selectedValue;
      let offset = (_a2 = document.getElementById(elemId)) == null ? void 0 : _a2.offsetTop;
      const listEl = listRef.current;
      const allOptionsEl = allOptionsRef.current;

      if ((allOptionsEl == null ? void 0 : allOptionsEl.ariaSelected) === "true") {
        offset = allOptionsEl == null ? void 0 : allOptionsEl.offsetTop;
      }

      if (listEl && typeof offset !== "undefined") {
        listEl.scrollTo({
          top: offset,
          behavior: "smooth"
        });
      }
    }
  }, [selectedValue]);
  const classNames = (0, import_core4.cx)(isExpanded && "is-expanded", (selectedValue || selectedValues.length > 0) && "has-selection", disabled && "is-disabled", showError && "has-error");
  const labelId = id + "_label";
  const selectedValueId = id + "_selected";
  const listId = id + "_list";
  const ownRef = (0, import_react14.useRef)(null);
  const buttonRef = forwardedRef || ownRef;
  const listRef = (0, import_react14.useRef)(null);
  const searchInputRef = (0, import_react14.useRef)(null);
  const allOptionsRef = (0, import_react14.useRef)(null);
  const childrenRef = (0, import_react14.useRef)([]);
  const multiselectIndex = (0, import_react14.useRef)(-1);
  const multiselectHoveredOption = (0, import_react14.useRef)(null);
  const keyboardEvents = useKeyboardEvents_default({
    initRef: buttonRef,
    listRef,
    searchInputRef,
    children,
    childrenRef,
    context: SelectContext,
    multiselectIndex,
    multiselectHoveredOption
  });

  const collapse = () => isExpanded && setIsExpanded(false);

  const outsideClickRef = useOutsideClickRef_default(collapse);

  const handleOnClick = () => {
    var _a2;

    (_a2 = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _a2.focus();
    setIsExpanded(!isExpanded);
  };

  const disableUpArrowScroll = event => {
    const {
      key
    } = event;

    if (key === "ArrowUp") {
      event.preventDefault();
    }
  };

  const displayValue = (0, import_react14.useMemo)(() => {
    const multiselectValue = selectedValues.length > 1 ? selectedValues[selectedValues.length - 1] + ", +" + ((selectedValues == null ? void 0 : selectedValues.length) - 1) + " more..." : selectedValues[0];
    return displayValueTransform(isMultiselect ? multiselectValue : selectedValue, isMultiselect ? selectedValues : [selectedValue]);
  }, [displayValueTransform, isMultiselect, selectedValue, selectedValues]);
  const selectAllConfig = (0, import_react14.useMemo)(() => {
    const isString = typeof selectAllOption === "string";
    return {
      enable: isString ? true : Boolean(selectAllOption != null ? selectAllOption : isMultiselect),
      label: isString ? selectAllOption : "Choose All"
    };
  }, [selectAllOption, isMultiselect]);
  return import_react14.default.createElement(SelectWrapper, {
    ref: outsideClickRef,
    style: __spreadValues({}, style),
    className: (0, import_core4.cx)(className, "select"),
    onKeyUp: keyboardEvents,
    onKeyDown: disableUpArrowScroll,
    "data-testid": testId
  }, import_react14.default.createElement(SelectInput, __spreadValues(__spreadValues({
    onClick: handleOnClick,
    "aria-haspopup": "listbox",
    "aria-labelledby": labelId + " " + selectedValueId,
    id,
    ref: buttonRef,
    className: classNames,
    type: "button"
  }, isExpanded && {
    "aria-expanded": true
  }), restProps), import_react14.default.createElement("div", null, import_react14.default.createElement("div", {
    id: labelId,
    className: "select__label"
  }, label), import_react14.default.createElement("span", {
    id: selectedValueId,
    className: "select__inputValue"
  }, displayValue)), isExpanded ? import_react14.default.createElement(CaretUp, null) : import_react14.default.createElement(CaretDown, {
    disabled
  })), caption && import_react14.default.createElement(SelectCaption, null, caption), showError && import_react14.default.createElement(SelectCaption, {
    className: "has-error"
  }, error), import_react14.default.createElement(OptionsContainer, __spreadProps(__spreadValues(__spreadValues({
    role: "listbox",
    className: classNames,
    "aria-labelledby": labelId,
    id: listId
  }, isExpanded && selectedValue && {
    "aria-activedescendant": id + "_" + selectedValue
  }), isMultiselect && {
    "aria-multiselectable": true
  }), {
    tabIndex: -1,
    ref: listRef,
    onMouseOver: clearMultiselectHoveredStyle,
    onBlur
  }), !!searchable && import_react14.default.createElement(SelectSearchInput_default, {
    ref: searchInputRef,
    callback: typeof searchable === "function" ? searchable : void 0
  }), isMultiselect && selectAllConfig.enable && import_react14.default.createElement(SelectAllOption_default, {
    ref: allOptionsRef,
    label: selectAllConfig.label,
    disabled
  }), import_react14.default.Children.toArray(children).map((child, index) => {
    const _child = child;
    return (0, import_react14.cloneElement)(_child, {
      ref(ref) {
        childrenRef.current[index] = ref;
      }

    });
  })));
};

var Select_default = (0, import_react14.forwardRef)((props, ref) => {
  var _b;

  const _a = props,
        {
    onChange,
    value = "",
    multiselect
  } = _a,
        restProps = __objRest(_a, ["onChange", "value", "multiselect"]);

  const {
    id
  } = props;
  const selectedValue = Array.isArray(value) ? (_b = value[value.length - 1]) != null ? _b : "" : value;
  const selectedValues = (typeof value === "string" ? [selectedValue] : value).filter(Boolean);
  return import_react14.default.createElement(SelectProvider, {
    isMultiselect: !!multiselect,
    menuId: id,
    selectedValue,
    selectedValues,
    onChange
  }, import_react14.default.createElement(BaseSelect, __spreadValues({
    forwardedRef: ref
  }, restProps)));
});
var states_default = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
};

var UsStatesSelect = _a => {
  var _b = _a,
      {
    id,
    onChange
  } = _b,
      restProps = __objRest(_b, ["id", "onChange"]);

  const [value, setValue] = (0, import_react15.useState)("");

  const renderStateOptions = () => Object.entries(states_default).map(_ref8 => {
    let [stateAbbr, stateFullName] = _ref8;
    return import_react15.default.createElement(Option_default, {
      key: stateAbbr,
      value: stateAbbr
    }, stateFullName);
  });

  const handleChange = event => {
    setValue(event.target.value);
  };

  return import_react15.default.createElement(Select_default, __spreadValues({
    id,
    value,
    displayValueTransform: stateAbbr => {
      return states_default[stateAbbr];
    },
    label: "state",
    onChange: e => {
      handleChange(e);
      if (onChange) onChange(e);
    }
  }, restProps), renderStateOptions());
};

var UsStatesSelect_default = UsStatesSelect;
var UsStatesSelect_default2 = UsStatesSelect_default;